import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';

const postPusherOrderRowSelect = createAsyncThunk('pusher/postPusherOrderRowSelect',
  async (formData = {}, { rejectWithValue }) => {
    try {
      const { data } = await authSet(METHOD_POST, '/pusher/select-order-row', formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postPusherOrderRowSelect;
